import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useSearchParams } from "react-router-dom";
import closeIcon from "../assets/images/close.svg";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import { apiCall } from "../services/AxiosService";
import { commonservices } from "../services/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import { userInfo } from "../services/ReduxTookit/UserInfoSlice";
import {
  SendEmailOtp,
  VerifyEmailOtp,
} from "../services/ReduxTookit/Slice/LoginRedux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const VerifyEmailModal = (props) => {
  let Userdata = useSelector((state) => state.userinfo.UserInfo);
  let dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [encryptedData, setEncryptedData] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const encryptedValue = searchParams.get("t");
    if (encryptedValue) {
      setEncryptedData(encryptedValue);
    }
  }, []);
  const [otpTimer, setOtpTimer] = useState(60);
  useEffect(() => {
    if (otpTimer > 0) {
      const timer = setInterval(() => {
        setOtpTimer(otpTimer - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [otpTimer]);

  const [input, setInput] = useState({
    Number1: "",
    Number2: "",
    Number3: "",
    Number4: "",
    Number5: "",
    Number6: "",
    errors: {
      Number1: "",
      Number2: "",
      Number3: "",
      Number4: "",
      Number5: "",
      Number6: "",
      ValidationRules: [
        {
          FieldName: "Number1",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number2",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number3",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number4",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number5",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "Number6",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const inputRefs = {
    Number1: useRef(),
    Number2: useRef(),
    Number3: useRef(),
    Number4: useRef(),
    Number5: useRef(),
    Number6: useRef(),
  };
  const fnInputChange = (value, tag) => {
    if (value) {
      setInput({
        ...input,
        [tag]: value,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
    } else {
      setInput({
        ...input,
        [tag]: "",
      });
    }
  };
  const handleInputChange = (e, inputName) => {
    fnInputChange(e.target.value, inputName); //added at 6-12-24
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      // setInput({ ...input, [inputName]: value });  //comment at 6-12-24
      if (value !== "" && inputName !== "Number6") {
        inputRefs[inputName]?.current?.blur();
        const nextInputName = `Number${
          parseInt(inputName.replace("Number", "")) + 1
        }`;
        inputRefs[nextInputName]?.current?.focus();
      }
    }
  };
  const handleKeyDown = (e, inputName) => {
    if (e.key === "Backspace") {
      if (e.target.value === "") {
        e.preventDefault();
        const currentIndex = parseInt(inputName.replace("Number", ""));
        if (currentIndex > 1) {
          const prevInputName = `Number${currentIndex - 1}`;
          inputRefs[prevInputName].current.focus();
        }
      }
    }
    if (e.key === "Enter" && e.target.value) {
      handleSubmit(e);
    }
  };
  const handlePaste = (event) => {
    const text = event.clipboardData.getData("text");
    let num1 = "",
      num2 = "",
      num3 = "",
      num4 = "",
      num5 = "",
      num6 = "";

    for (let i = 0; i < text?.length; i++) {
      if (i === 0) {
        num1 = text?.[i];
      } else if (i === 1) {
        num2 = text?.[i];
      } else if (i === 2) {
        num3 = text?.[i];
      } else if (i === 3) {
        num4 = text?.[i];
      } else if (i === 4) {
        num5 = text?.[i];
      } else if (i === 5) {
        num6 = text?.[i];
      }
    }

    setInput({
      ...input,
      Number1: num1,
      Number2: num2,
      Number3: num3,
      Number4: num4,
      Number5: num5,
      Number6: num6,
    });
  };
  const [VerifymailLoader, setVerifymailLoader] = useState(false);

  async function getVerifyOTPemail(mail) {
    setVerifymailLoader(true);
    let body = {
      email: mail,
    };
    dispatch(SendEmailOtp(body)).then((res) => {
      if (res?.payload?.isValidate) {
        // setVerifyModalShow(true);
        setOtpTimer(60);
        setVerifymailLoader(false);
      } else {
        setVerifymailLoader(false);
      }
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        email: props?.mail?.trim(),
        otp:
          input.Number1 +
          input.Number2 +
          input.Number3 +
          input.Number4 +
          input.Number5 +
          input.Number6,
      };

      dispatch(VerifyEmailOtp(body)).then((res) => {
        if (res?.payload?.isValidate) {
          setLoading(false);
          // navigate(`/change-password/${encryptedData}`);
          props.verifytext("success");
          props.handleEmailvalid();
          // props.bindlist();
          props.setinputdata(props?.inputdata);
          let proinfo = {
            ...Userdata,
            isemailverified: true,
          };
          dispatch(userInfo(proinfo));
          props.onHide();
        } else {
          setLoading(false);
        }
      });

      // ------------- Before redux
      // let resData = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.LOGIN.VERIFY_EMAIL_OTP,
      //     body: body,
      //   },
      //   true
      // );
      // let response = apiResponse(true, resData, setLoading);
      // if (response?.isValidate) {
      //   // navigate(`/change-password/${encryptedData}`);
      //   props.verifytext("success");
      //   props.handleEmailvalid();
      //   props.bindlist();
      //   props.onHide();
      // }
      // if (!response?.isValidate) {
      // }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="enter-otp-pop-up"
      backdrop="static"
    >
      {Loading && <MainpageLoader />}
      <div className="main-login-form">
        <div
          className="d-flex cursor-pointer
    justify-content-between     align-items-baseline"
        >
          <h3>Enter OTP</h3>
          <img onClick={() => props?.onHide()} src={closeIcon} />
        </div>
        <p>Please enter the OTP sent to your</p>
        <p>
          Mail ID <span className="theme-color-text">{props?.mail}</span>
        </p>
        <div className="login-form-inner">
          <Form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Form.Group className="form-group">
              <Form.Label className="login-label">
                OTP<span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <Row>
                <Col md={2}>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      className="login-input text-center"
                      maxLength={1}
                      ref={inputRefs.Number1}
                      value={input.Number1}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleInputChange(e, "Number1")}
                      onKeyUp={(e) => handleKeyDown(e, "Number1")}
                      isInvalid={input?.errors?.Number1}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onPaste={handlePaste}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      className="login-input text-center"
                      maxLength={1}
                      value={input.Number2}
                      ref={inputRefs.Number2}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleInputChange(e, "Number2")}
                      onKeyUp={(e) => handleKeyDown(e, "Number2")}
                      isInvalid={input?.errors?.Number2}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      className="login-input text-center"
                      maxLength={1}
                      ref={inputRefs.Number3}
                      value={input.Number3}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleInputChange(e, "Number3")}
                      onKeyUp={(e) => handleKeyDown(e, "Number3")}
                      isInvalid={input?.errors?.Number3}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      className="login-input text-center"
                      maxLength={1}
                      value={input.Number4}
                      ref={inputRefs.Number4}
                      onChange={(e) => handleInputChange(e, "Number4")}
                      onKeyUp={(e) => handleKeyDown(e, "Number4")}
                      onFocus={(e) => e.target.select()}
                      isInvalid={input?.errors?.Number4}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      className="login-input text-center"
                      maxLength={1}
                      ref={inputRefs.Number5}
                      value={input.Number5}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleInputChange(e, "Number5")}
                      onKeyUp={(e) => handleKeyDown(e, "Number5")}
                      isInvalid={input?.errors?.Number5}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      className="login-input text-center"
                      maxLength={1}
                      ref={inputRefs.Number6}
                      value={input.Number6}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleInputChange(e, "Number6")}
                      onKeyUp={(e) => handleKeyDown(e, "Number6")}
                      isInvalid={input?.errors?.Number6}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Form.Group>
            <div className="d-flex  mb-3   justify-content-between">
              <div className="register-link-wrapper ">
                Don't receive the code?
                <button
                  type="reset"
                  disabled={otpTimer ? "disable" : ""}
                  className={otpTimer ? "disable" : ""}
                  title="Resend"
                  onClick={() => getVerifyOTPemail(props?.mail)}
                >
                  Resend
                </button>
                {VerifymailLoader && (
                  <>
                    <Spinner
                      className="ms-1"
                      animation="border"
                      role="status"
                      size="sm"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </>
                  // <SubmitLoading />
                )}
              </div>
              <span className="theme-color-text">
                {otpTimer === 60
                  ? "00:00"
                  : `00:${otpTimer < 10 ? `0${otpTimer}` : otpTimer}`}
              </span>
            </div>

            <button
              disabled={Loading}
              className="blue-sign-in-btn w-100"
              type="submit"
              title="Submit"
            >
              {Loading ? (
                // <>
                //   <span>Loading</span>{" "}
                //   <Spinner
                //     className="ms-1"
                //     animation="border"
                //     role="status"
                //     size="sm"
                //   >
                //     <span className="visually-hidden">Loading...</span>
                //   </Spinner>
                // </>
                <SubmitLoading />
              ) : (
                "Submit"
              )}
            </button>
          </Form>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </Form> */}
    </Modal>
  );
};

export default VerifyEmailModal;
